<script lang="ts">
	import favicon from '#lib/assets/favicon.png';

	let { children } = $props();
</script>

<svelte:head>
	<link rel="icon" href={favicon} />
</svelte:head>

{@render children()}

<style>
	:root {
		--font-family--default: Arial;

		/* --font-size--small: 2vh;
		--font-size--medium: 3vh;
		--font-size--large: 4vh; */

		--color--white: #ffffff;
		--color--grey-light: #f0f0f0;
		--color--grey-medium: #a0a0a0;
		--color--grey-dark: #505050;
		--color--green-light-x: #d0ffc0;
		--color--green-light: #c0f0a0;
		--color--green-medium: #60a040;
		--color--green-dark: #004000;
		
		--color--transparent-border: #FFFFFF00; /* used to make outlines transparent while still keeping their width */
		--color--correct: var(--color--green-light);
		--color--incorrect: rgb(229, 186, 86);
		--color--highlighted-yellow: #f3ff89;
		
		--color--topbarButton-background: var(--color--green-light);
		--color--background-default: #EEEEEE;
		--color--background-turquoise: #e0f8f0; /*#D0F0E0*/
		
		--color--paper-white: #FFFFFF;
		--color--paper-flipped: grey;
		--color--image-border: darkgray;
		
		--color--letter-default: white;
		--color--letter-hover: #EEFFEE;
		--color--letter-flipped: darkgrey;
		--color--letter-target: darkgray;
		--color--keyboard-button-default: lightgrey;
		--color--keyboard-button-hover: white;
		
		--color--speakDialog-background: lightgrey;


		--topbar--height: 15%; /* nicht die PatientTopBar, sondern die andere */
		
		--image-width: calc(.45 * var(--step-div-height));
		--image-height: calc(3/4 * var(--image-width));
		--paper-height: 5vmin;

		--image-border-width: 1vmin;
		--paper-border-width: 0.5vmin;
		--image-border-height: calc(
			var(--paper-height) + var(--image-height) + 2 * var(--image-border-width)
		);

		--z-index--popup: 100;
		--z-index--cursor: 200;

		--letter-paper-font-size: x-large;
		--letter-target-border-width: 0.2em;
	}

	/* for the Cursor.svelte to be visible everywhere on the page, not just the top 3cm*/
	:global(body, html) {
		height: 100%;
		width: 100%;

		margin: 0;
		padding: 0;

		background-color: var(--color--background-turquoise);

		font-family: var(--font-family--default);
		font-size: var(--font-size--medium);

		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: center;
		align-self: center;

		overflow: hidden;
	}
	:global(body) {
		anchor-name: --body-anchor;
	}
	:global(button) {
		/* transition-duration: 0.1s; */
		cursor: pointer;
	}

	/** class for elements that should not be selected or marked with a pointer */
	:global(.unselectable) {
		pointer-events: none;
		user-select: none;
	}
</style>
